module.exports = __webpack_public_path__ + "p4_img7.jpg?fea62e6b963623fff3e57609082c180e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img7.jpg
// module id = 114
// module chunks = 0